var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"helper-btn",class:_vm.size ? `helper-btn--${_vm.size}` : '',attrs:{"disabled":_vm.disabled}},[(_vm.icon)?_c(_vm.icon,{tag:"component",attrs:{"fill":_vm.fill}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }